import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import { fetchCertificates } from 'store/api/applications/application/certificates/certificatesActions';
import { ApplicationType, CertificatesDetailsResponse, CertificateType } from 'store/api/types';

import { CertificatesGroup } from './CertificatesGroup';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onFetchCertificates: (accountId: string, applicationId: string, certificateType: CertificateType) =>
    dispatch<Promise<CertificatesDetailsResponse>>(
      fetchCertificates(accountId, applicationId, ApplicationType.PSD2, certificateType),
    ),
});

export const CertificatesGroupContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(CertificatesGroup);
